import { createFileRoute } from '@tanstack/react-router'
import { Parcerias } from '../../../app/financial/parcerias'

export const Route = createFileRoute('/_auth/financial/parcerias/')({
  component: Parcerias,
})
